import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import type { IPopCardAutomationIds } from "./automationIds";
import { ConversionRatePopBarRow } from "./ConversionRatePopBarRow";

interface IConversionRatePopBarsProps {
    comparedRowLabel: string;
    currentRowLabel: string;
    comparedValue: number;
    originalValue: number;
    change: number | null | undefined;
    changeSuffix: string;
    formatValue: (value: number) => string;
    formatChange: (change: number) => string;
    automationIds: IPopCardAutomationIds;
}

const calculateBarFraction = (value: number, maxValue: number): number => {
    if (maxValue <= 0) {
        return 0;
    }
    return value / maxValue;
};

export const ConversionRatePopBars = ({
    comparedRowLabel,
    currentRowLabel,
    comparedValue,
    originalValue,
    change,
    changeSuffix,
    formatValue,
    formatChange,
    automationIds,
}: IConversionRatePopBarsProps) => {
    const maxValue = Math.max(originalValue, comparedValue);
    const comparedBarFraction = calculateBarFraction(comparedValue, maxValue);
    const currentBarFraction = calculateBarFraction(originalValue, maxValue);

    return (
        <Flex
            flexDirection="column"
            padding="16px 24px"
            gap="16px"
            flex="1"
        >
            <ConversionRatePopBarRow
                automationIds={automationIds.compared}
                rowLabel={comparedRowLabel}
                value={comparedValue}
                barFraction={comparedBarFraction}
                formatValue={formatValue}
                barColor={colorsPalettes.orange[400]}
            />
            <ConversionRatePopBarRow
                automationIds={automationIds.current}
                rowLabel={currentRowLabel}
                value={originalValue}
                barFraction={currentBarFraction}
                formatValue={formatValue}
                barColor={colorsPalettes.blue[400]}
                change={change}
                formatChange={formatChange}
                changeSuffix={changeSuffix}
            />
        </Flex>
    );
};
